"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _util = require("@plugnet/util");

var _Bytes = _interopRequireDefault(require("./Bytes"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name StorageKey
 * @description
 * A representation of a storage key (typically hashed) in the system. It can be
 * constructed by passing in a raw key or a StorageFunction with (optional) arguments.
 */
class StorageKey extends _Bytes.default {
  constructor(value) {
    super(StorageKey.decodeStorageKey(value));
    this._meta = void 0;
    this._outputType = void 0;
    this._meta = StorageKey.getMeta(value);
    this._outputType = StorageKey.getType(value);
  }

  static decodeStorageKey(value) {
    if ((0, _util.isFunction)(value)) {
      return value();
    } else if (Array.isArray(value)) {
      const [fn, ...arg] = value;

      if ((0, _util.isFunction)(fn)) {
        return fn(...arg);
      }
    }

    return value;
  }

  static getMeta(value) {
    if (value instanceof StorageKey) {
      return value.meta;
    } else if ((0, _util.isFunction)(value)) {
      return value.meta;
    } else if (Array.isArray(value)) {
      const [fn] = value;
      return fn.meta;
    }

    return null;
  }

  static getType(value) {
    if (value instanceof StorageKey) {
      return value.outputType;
    } else if ((0, _util.isFunction)(value)) {
      return value.meta.type.toString();
    } else if (Array.isArray(value)) {
      const [fn] = value;
      return fn.meta.type.toString();
    }

    return null;
  }
  /**
   * @description The metadata or `null` when not available
   */


  get meta() {
    return this._meta;
  }
  /**
   * @description The output type, `null` when not available
   */


  get outputType() {
    return this._outputType;
  }

}

exports.default = StorageKey;